import React, { Component } from 'react';
import styled from 'styled-components';
import { getTheme } from '../../global/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/pro-solid-svg-icons';

const EditInPlaceWrapper = styled.span`
  position: relative;
  display: block;
  input {
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    padding: 0;
    border: 0;
    font-family: inherit;
    max-width: calc(100% - 2em);
    line-height: 1.3;
  }
  .editinplace__icon {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    background: ${getTheme('bg', 'light1')};
    padding: 0.2rem;
    opacity: 0;
    pointer-events: none;
    transition: 0.3s opacity;
  }
  &:hover .editinplace__icon {
    opacity: 1;
  }
`;

class EditInPlace extends Component {
  render() {
    return (
      <EditInPlaceWrapper size={this.props.size}>
        <input type="text" defaultValue={this.props.value} onChange={this.props.onChange} />
        <FontAwesomeIcon className="editinplace__icon" icon={faPencil} />
      </EditInPlaceWrapper>
    );
  }
}

export default EditInPlace;



// WEBPACK FOOTER //
// ./src/components/forms/EditInPlace.js